export const LOGIN_LOADER: string = 'LOGIN_LOADER'
export const LOGIN_SUCCESS: string = 'LOGIN_SUCCESS'
export const LOGIN_FAIL: string = 'LOGIN_FAIL'
export const LOGIN_RESET: string = 'LOGIN_RESET'
export const LOGIN_TOEKN: string = 'LOGIN_TOEKN'
export const CONNECTION_TOEKN: string = 'CONNECTION_TOEKN'
